export function getOwaNetCoreEndpoint(owaEndpoint: string) {
    return owaEndpoint.replace('/owa/', '/owanetcore/');
}
